<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="ProfileViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{user.displayName}}</p>
                <p>{{user.email}}</p>
                <br>
                <button v-on:click="edit" type="button" class="btn  btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="ProfileEditing col-md-5" v-show="isEditing">
              <div v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99">
                <form-text ref="name" styler="font-size:35px" label="Name" name="name" v-model="userEdit.displayName" validation="required"></form-text>
              </div>
              <div v-else>
                <p style="font-size:35px">{{user.displayName}}</p>
              </div>

              <form-text ref="email" label="Email" name="email" v-model="userEdit.email" validation="required|email"></form-text>

              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
              </div>
            </div>
            <hr/>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs">
                  <li role="presentation" class="nav-item">
                    <a href="#tab-orgs" role="tab" data-toggle="tab" class="nav-link active">Organizations</a>
                  </li>
                  <li role="presentation" class="nav-item">
                    <a href="#tab-notificationtriggers" role="tab" data-toggle="tab" class="nav-link">Notification Triggers</a>
                  </li>
                  <li role="presentation" class="nav-item">
                    <a href="#tab-pwdreset" role="tab" data-toggle="tab" class="nav-link">Password Reset</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div role="tabcard" class="tab-pane fade in active" id="tab-orgs">
                    <data-table :data="orgs" :columns="columns" :filter-key="searchQuery"></data-table>
                  </div>
                  <div role="tabcard" class="tab-pane fade" id="tab-notificationtriggers">
                    <div class="col-md-5">
                      <div class="checkbox">
                          <input type="checkbox" class="" id="emailnotif" name="emailnotif" v-model="triggers.emailnotif" @change="updateTriggers">
                          <label class="col-form-label"> &nbsp Late Workflow Emails</label>
                      </div>
                    </div>
                  </div>
                  <div role="tabcard" class="tab-pane fade" id="tab-pwdreset">
                    <br>
                    <div class="col-md-5">
                      <div class="form-group" :class="{ 'has-danger' : errors.has('pwdold') }">
                        <div class="has-float-label">
                          <input type="password" class="form-control" id="pwdold" name="pwdold" v-model="pwd.old" v-validate="'required'" placeholder="Old Password">
                          <label :for="'pwdold'">Old Password</label>
                          <div class="form-control-feedback" v-if="errors.has('pwdold')">{{ errors.first('pwdold') }}</div>
                        </div>
                      </div>   
                      <div class="form-group" :class="{ 'has-danger' : errors.has('pwdnew') }">
                        <div class="has-float-label">
                          <input type="password" class="form-control" id="pwdnew" name="pwdnew" v-model="pwd.new" v-validate="'required|min:6'" placeholder="New Password">
                          <label :for="'pwdnew'">New Password</label>
                          <div class="form-control-feedback" v-if="errors.has('pwdnew')">{{ errors.first('pwdnew') }}</div>
                        </div>
                      </div>   
                      <div class="form-group" :class="{ 'has-danger' : errors.has('pwdnewverify') }">
                        <div class="has-float-label">
                          <input type="password" class="form-control" id="pwdnewverify" name="pwdnewverify" v-model="pwd.newverify" v-validate="'required|confirmed:pwdnew'" data-vv-as="pwdnew" placeholder="Verify New Password">
                          <label :for="'pwdnewverify'">Verify New Password</label>
                          <div class="form-control-feedback" v-if="errors.has('pwdnewverify')">{{ errors.first('pwdnewverify') }}</div>
                        </div>
                      </div>   
                    </div>
                    <br>
                    <div class="col-md-5">
                      <button v-on:click="resetPwd" type="button" class="btn  btn-success">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../elements/Form/FormText'
import DataTable from './UserOrganizationsTable'
import database from '../webmaster/Database/database'
import firebase from 'firebase'

Vue.use(VueMask);
Vue.use(VeeValidate);

import auth from '../webmaster/Authentication/auth'
import store from '../webmaster/Store/vuex'
const user = auth.getUser()

export default {
  name: 'profile',
  components:{
    'data-table':DataTable,
    'form-text':FormText,
  },
  data () {
    return {
      user,
      userEdit:{},
      triggers: {},
      isEditing: false,
      searchQuery: '',
      columns: ['name', 'select'],
      org: store.state.usermain,
      orgs: [],
      pwd: {
        old: '',
        new: '',
        newverify: ''
      }
    }
  },
  created:function(){
    //Assing user variables to userEdit
    this.userEdit = Object.assign({}, this.userEdit, this.user);

    this.$bindAsObject('triggers', database.getRef('/users/' + this.user.uid + '/orgs/' + this.$store.state.usermain.curOrg.id));
    //Init orgs from allOrgs object
    this.$bindAsArray('orgs', database.getRef('/users/' + this.user.uid + '/orgs').orderByChild("active").equalTo(true));
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(() => { 
        this.updateNameOrgs(database.getDb().ref(), self.userEdit.uid, self.userEdit.displayName).then(_ => {
          auth.updateUser(this.userEdit);
          self.user = Object.assign({}, self.user, self.userEdit);
          self.isEditing = false;
        }).catch(err => {
          console.log(err)
        });
      }, () => {});
    },
    updateTriggers:function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(() => { 
        this.updateNotifTriggers(database.getDb().ref(), self.userEdit.uid, self.triggers.emailnotif).then(_ => {
          auth.updateUser(this.userEdit);
          self.user = Object.assign({}, self.user, self.userEdit);
          self.isEditing = false;
        }).catch(err => {
          console.log(err)
        });
      }, () => {});

    },
    updateNotifTriggers:function(rootRef, uid, emailnotif){
      let updateObj = {}
      updateObj['/orgs/' + this.$store.state.usermain.curOrg.id + '/users/' + uid + '/emailnotif'] = emailnotif
      updateObj['/users/' + uid + '/orgs/' + this.$store.state.usermain.curOrg.id + '/emailnotif'] = emailnotif
      console.log(updateObj)
      return rootRef.update(updateObj)
      
    },
    updateNameOrgs: function(rootRef, uid, name){
      const userOrgs = database.getRef('/users/' + user.uid + '/orgs')
      return userOrgs.once('value').then(snap => {
        let orgKeys = Object.keys(snap.val());
        let updateObj = {}

        let promises = [];

        orgKeys.forEach(key => {
          updateObj['/orgs/' + key + '/users/' + uid + '/name'] = name;

          var newPromise = database.getRef("/orgs/" + key + "/wire/users/" + uid).once('value').then(wireUserSnapshot => {
            console.log(wireUserSnapshot.val());
            if (wireUserSnapshot.val() != null) {
              updateObj["/orgs/" + key + "/wire/users/" + uid + "/name"] = name;

              if (wireUserSnapshot.val().chats != null) {
                var chatIds = Object.keys(wireUserSnapshot.val().chats);

                chatIds.forEach(function (chatId) {
                  updateObj['/orgs/' + key + '/wire/chats/' + chatId + '/members/' + uid] = name;
                });
              }
            }
          })

          promises.push(newPromise);
        });

        return Promise.all(promises).then(_ => {
          return rootRef.update(updateObj);
        })
      });
    },
    resetPwd: function(){
      this.$validator.validateAll().then(() => {
        var self = this
        var user = firebase.auth().currentUser;
        var newPwd = self.pwd.new
        var oldPwd = self.pwd.old
        var credential = firebase.auth.EmailAuthProvider.credential(
          user.email,
          oldPwd
        );
        user.reauthenticateWithCredential(credential).then(() => {
          user.updatePassword(newPwd).then(function() {
            // Update successful.
            self.pwd.old = ''
            self.pwd.new = ''
            self.pwd.newverify = ''
            self.$validator.clean()
            self.$swal('Success',
                    'Your password has been changed!',
                    'success')
          }, function(error) {
            // An error happened.
            console.log(error)
            self.pwd.old = ''
            self.pwd.new = ''
            self.pwd.newverify = ''
            self.$swal('Oops...',
                    'We had a little error!',
                    'error')
          });
          
        }).catch((error) => {
          console.log(error)
          self.$swal('Oops...',
                    'Your old password is not valid!',
                    'error')
        });

        
      }).catch(() => {
          // eslint-disable-next-line

      });

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Profile.vue?5fd97174